module.exports = __webpack_public_path__ + "img/scc-01-flat.0bc30779.png";